import React, { Component } from 'react'

import EnquireNowButton from '../EnquireNowButton'

import {
  ResponsiveContainer,
  Container,
  Heading,
  EligibilityImage,
  Underline,
  HeadingWrapper,
  ButtonWrapper,
  ImageContainer
} from './styledComponents'
import PlacesListToPlayIbcricket from './PlacesListToPlayIbcricket'

export default class PlacesToPlayIbcricket extends Component {
  render() {
    const {
      PlacesToPlayIbcricketData: {
        heading,
        eligibilityImage,
        placesList,
        eligibilityImagealt
      },
      formData,
      glsLoaded
    } = this.props
    return (
      <Container id="places-to-play-ibcricket">
        <ResponsiveContainer>
          <HeadingWrapper>
            <Heading>{heading}</Heading>
            <Underline />
          </HeadingWrapper>
          <ImageContainer>
            <EligibilityImage
              dataSrc={eligibilityImage}
              alt={eligibilityImagealt}
              className="lazyload"
            />
          </ImageContainer>
          <PlacesListToPlayIbcricket placesList={placesList} />
          <ButtonWrapper>
            <EnquireNowButton
              id={'places-to-play-ibcricket-enquire-button'}
              formData={formData}
              glsLoaded={glsLoaded}
              text="ENQUIRE NOW"
            />
          </ButtonWrapper>
        </ResponsiveContainer>
      </Container>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/ExperimentalMarketing/PlacesToPlayIbcricket/index.js